import { render, staticRenderFns } from "./dropdown.vue?vue&type=template&id=36cdf06a&scoped=true"
import script from "./dropdown.vue?vue&type=script&lang=ts"
export * from "./dropdown.vue?vue&type=script&lang=ts"
import style0 from "./dropdown.vue?vue&type=style&index=0&id=36cdf06a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cdf06a",
  null
  
)

export default component.exports